import { LmgService } from "../resource";

const BillingModule = {
  namespaced: true,
  state: {
    datas: [],
    datas_duedate : [],
    data: {},
    billing_status: [
      { ID: 1, Name: "จ่ายแล้ว" },
      { ID: 2, Name: "ยังไม่จ่าย" }
    ],
    isLoading: false,
    isLoadingDuedate: false,
    // Monotonic counters — each list* call bumps its counter; stale
    // responses (seq != current) are dropped so fast repeat clicks
    // can't overwrite newer results.
    _listDataSeq: 0,
    _listDuedateSeq: 0,
  },
  mutations: {
    SET_DATAS(state, payload) {
      state.datas = payload;
    },
    SET_DATAS_DUEDATE(state, payload) {
      state.datas_duedate = payload;
    },
    SET_DATA(state, payload) {
      state.data = payload;
    },
  },
  actions: {
    createData({ commit, state }, payload) {
      return LmgService.BillingCreate(payload);
    },
    async listData({ commit, state },payload) {
      state._listDataSeq += 1;
      const mySeq = state._listDataSeq;
      state.isLoading = true;
      try {
        const data = await LmgService.BillingList(payload);
        if (mySeq !== state._listDataSeq) return;
        if (data.data.Data == null) {
          commit("SET_DATAS", []);
        } else {
          commit("SET_DATAS", data.data.Data);
        }
        state.isLoading = false;
      } catch (err) {
        if (mySeq !== state._listDataSeq) return;
        commit("SET_DATAS", []);
        state.isLoading = false;
      }
    },


	async listBillingDuedate({ commit, state },payload) {
		state._listDuedateSeq += 1;
		const mySeq = state._listDuedateSeq;
		state.isLoadingDuedate = true;
		try {
			const data = await LmgService.BillingReportList(payload);
			if (mySeq !== state._listDuedateSeq) return;
			commit("SET_DATAS_DUEDATE", data.data.Data == null ? [] : data.data.Data);
			state.isLoadingDuedate = false;
		} catch (err) {
			if (mySeq !== state._listDuedateSeq) return;
			commit("SET_DATAS_DUEDATE", []);
			state.isLoadingDuedate = false;
		}
	  },



  },
  getters: {
    getData(state) {
      return state.datas;
    },
	getDataDueDate(state) {
		return state.datas_duedate;
	},
	isLoading(state) {
		return state.isLoading;
	},
	isLoadingDuedate(state) {
		return state.isLoadingDuedate;
	},

    getBillingStatusNameWithAll(state){
      return [{ID:0, Name : "ทั้งหมด"},...state.billing_status];
    },
    getBillingStatusName( state ){
      var self = this;
      return function (id){
        let s =  state.billing_status.filter(f => {
          return f.ID == id;
        });
        return s.length == 0 ? 'Unknown' : s[0].Name
      }
    },
    
  }
};

export default BillingModule;
